var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMlrDraft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 11.9985C2.69043 11.9985 0 9.30518 0 5.99658C0 2.68994 2.69043 -0.00146484 5.99805 -0.00146484C9.30762 -0.00146484 12 2.68994 12 5.99658C12 9.30518 9.30762 11.9985 5.99805 11.9985ZM6.56934 4.38525L3.50098 7.45947V8.49854H4.54004L7.61426 5.43018L6.56934 4.38525ZM7.57129 3.50244C7.49805 3.50244 7.42773 3.52979 7.375 3.58057L6.86816 4.09229L7.90723 5.13135L8.41992 4.62354C8.52539 4.51221 8.52539 4.34229 8.41992 4.23096L7.76758 3.58057C7.71484 3.52979 7.64453 3.50244 7.57129 3.50244Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlrDraft);
export default __webpack_public_path__ + "static/media/MLR_Draft.88df5daa2fda23071437a1ba46e75bcc.svg";
export { ForwardRef as ReactComponent };